<template>
  <div class="page-content form-submit-page" style="margin-top: 20px">
    <el-row class="search-title common-table-top">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span" style="margin-left:6px">添加会员权益</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
      </el-col>
    </el-row>
    <el-row class="box-content">
      <div class="box-content-div form-submit-page">
        <el-form :inline="false" :model="formInline" ref="formInline" :rules="rules" class="box-content-form" label-width="100px">
          <el-form-item label="权益名称:" prop="in_title">
            <el-input v-model="formInline.in_title" placeholder="请输入权益名称"></el-input>
          </el-form-item>
          <el-form-item label="权益类型:" prop="in_type">
            <el-select v-model="formInline.in_type" placeholder="请选择">
              <el-option
                v-for="item in interestOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="链接地址" v-if="formInline.in_type === 1 || formInline.in_type === ''">
            <el-input v-model="formInline.in_url" placeholder="请输入链接地址"></el-input>
          </el-form-item>
          <el-form-item label="礼物名称:" v-if="formInline.in_type === 2">
            <el-input v-model="formInline.in_gift_name" placeholder="请输入礼物名称"></el-input>
          </el-form-item>
          <el-form-item label="礼物编号:" v-if="formInline.in_type === 2">
            <el-input v-model="formInline.pro_code" placeholder="礼物编号是外部商品编号，比如管易的"></el-input>
          </el-form-item>
          <el-form-item label="权益分类:" prop="in_classify">
            <el-select v-model="formInline.in_classify" placeholder="请选择">
              <el-option
                v-for="item in classifyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="会员日:" v-if="formInline.in_classify === '' || formInline.in_classify === 2">
            <el-select v-model="formInline.in_member_day" placeholder="请选择会员日">
              <el-option
                v-for="item in memberDayOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间:" v-if="formInline.in_classify === '' || formInline.in_classify === 1" prop="in_classify">
            <el-date-picker style="width:193px;"
              v-model="formInline.in_start"
              type="datetime"
              placeholder="开始时间"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间:" v-if="formInline.in_classify === '' || formInline.in_classify === 1" prop="in_classify">
            <el-date-picker style="width:193px;"
              v-model="formInline.in_end"
              type="datetime"
              placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="权益适用等级:" prop="in_grade_list">
            <el-select v-model="interestFitValue" multiple placeholder="请选择权益适用等级" @change="interestFitChange" class="interest-type">
              <el-option
                v-for="item in interestFitOptions"
                :key="item.id"
                :label="item.level_title"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="权益图标:" prop="in_logo">
            <el-upload
              class="interest-uploader"
              name="file_upload"
              :action="uploadURL"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <div v-if="formInline.in_logo" class="opacity-div">
                <img :src="formInline.in_logo" class="interest-image">
                <div class="back-div">点击更换</div>
              </div>
              <div slot="tip" style="line-height:20px;color:#606266;">必填！建议尺寸340*340</div>
              <img v-if="formInline.in_logo === ''" src="../../assets/images/Group.png" class="default-images">
            </el-upload>
          </el-form-item>
          <el-form-item label="未点亮图标:" prop="in_fit_logo">
            <el-upload
              class="interest-uploader"
              name="file_upload"
              :action="uploadURL"
              :show-file-list="false"
              :on-success="handleFilesSuccess"
              :before-upload="beforeAvatarUpload">
              <div v-if="formInline.in_fit_logo"  class="opacity-div1">
                <img :src="formInline.in_fit_logo" class="interest-image">
                <div class="back-div">点击更换</div>
              </div>
              <div slot="tip" style="line-height:20px;color:#606266;">必填！建议尺寸340*340</div>
              <img v-if="formInline.in_fit_logo === ''"  src="../../assets/images/Group.png" class="default-images">
            </el-upload>
          </el-form-item>
          <el-form-item label="内容:">
            <el-input v-model="formInline.in_content" type="textarea" :rows="4" ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button class="second-page-btn" style="float: left;margin-top: 70px;" type="primary" @click="submitForm('formInline')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
  </div>
</template>
<script>
import { API_HOST } from '@/api/local'
import { addMemberInterest, getMemberLevelList } from '@/api/customer.js'
export default {
  name: '',
  data () {
    return {
      interestValue: '',
      in_type: '',
      interestOptions: [
        {
          value: 1,
          label: '链接'
        },
        {
          value: 2,
          label: '实物'
        }
      ],
      interestFitValue: [],
      interestFitOptions: [],
      classifyOptions: [
        // {
        //   label: '请选择',
        //   value: ''
        // },
        {
          label: '节日福利',
          value: 1
        },
        {
          label: '会员专属日',
          value: 2
        },
        {
          label: '生日福利',
          value: 3
        }
      ],
      memberDayOptions: [
        {
          label: '星期一',
          value: '1'
        },
        {
          label: '星期二',
          value: '2'
        },
        {
          label: '星期三',
          value: '3'
        },
        {
          label: '星期四',
          value: '4'
        },
        {
          label: '星期五',
          value: '5'
        },
        {
          label: '星期六',
          value: '6'
        },
        {
          label: '星期日',
          value: '7'
        }
      ],
      formInline: {
        in_classify: '',
        in_grade_list: '',
        in_title: '',
        in_type: '',
        in_url: '',
        in_gift_name: '',
        in_member_day: '',
        in_start: '',
        in_end: '',
        in_logo: '',
        in_fit_logo: '',
        in_content: '',
        pro_code: ''
      },
      rules: {
        in_title: [
          { required: true, message: '请输入权益名称', trigger: 'blur' }
        ],
        in_type: [
          { required: true, message: '请选择权益类型', trigger: 'change' }
        ],
        in_classify: [
          { required: true, message: '请选择权益分类', trigger: 'change' }
        ],
        in_logo: [
          { required: true, message: '请上传权益图标', trigger: 'change' }
        ],
        in_fit_logo: [
          { required: true, message: '请上传未点亮图标', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    uploadURL() {
      return API_HOST + 'admin/Upload/upload'
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.formInline.in_type === 1 && this.formInline.in_url === '') {
            _g.toastMsg('error', '请输入链接')
            return
          }
          if (this.formInline.in_type === 2 && this.formInline.in_gift_name === '') {
            _g.toastMsg('error', '请输入礼品名称')
            return
          }
          if (this.formInline.in_classify === 1 && this.formInline.in_start === '') {
            _g.toastMsg('error', '请输入开始时间')
            return
          }
          if (this.formInline.in_classify === 1 && this.formInline.in_end === '') {
            _g.toastMsg('error', '请输入结束时间')
            return
          }
          if (this.formInline.in_classify === 2 && this.formInline.in_member_day === '') {
            _g.toastMsg('error', '请选择会员日')
            return
          }
          if (this.formInline.in_logo === '') {
            _g.toastMsg('error', '请上传权益图标')
            return
          }
          if (this.formInline.in_fit_logo === '') {
            _g.toastMsg('error', '请上传未点亮图标')
            return
          }
          if (this.interestFitValue.length === 0) {
            _g.toastMsg('error', '请选择权益适用等级')
            return
          }
          this.addMemberInterestAction()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    interestFitChange() {
      this.formInline.in_grade_list = this.interestFitValue.toString()
    },
    // 会员未点亮
    handleFilesSuccess(res, file) {
      _g.toastMsg('success', '上传成功')
      this.formInline.in_fit_logo = res.data.path
      console.log(res.data.path)
    },
    // 会员权益图标
    handleAvatarSuccess(res, file) {
      _g.toastMsg('success', '上传成功')
      this.formInline.in_logo = res.data.path
      console.log(res.data.path)
    },
    beforeAvatarUpload(file) {
      _g.toastMsg('success', '正在上传')
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return (isJPG && isLt2M) || (isPNG && isLt2M)
    },
    addMemberInterestAction() {
      addMemberInterest(this.formInline).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          router.push('/home/member-interest-setting')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    loadMemberLevelList() {
      getMemberLevelList().then(res => {
        this.interestFitOptions = res.data.data.list
      })
    }
  },
  created() {
    this.loadMemberLevelList()
  },
  components: {
  }
}
</script>

<style scoped>
.page-content {
  overflow-x: hidden;
}
.box-content-div {
  width: 890px;
  margin: 0 auto;
}
.box-content-form {
  margin: 61px auto;
  text-align: center;
  padding-left: 135px;
}
.box-content-form .el-form-item {
  width: 100%;
}
.avatar-uploader {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.interest-image {
  width: 178px;
  height: 178px;
  position: relative;
}
.opacity-div {
  padding: 0 auto;
}
.opacity-div1:hover .back-div {
  opacity: 1 !important;
}
.opacity-div:hover .back-div {
  opacity: 1 !important;
}
.back-div {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 178px;
  height: 178px;
  top: 0;
  left: 10;
  opacity: 0;
  cursor: pointer;
  color: #fff;
  line-height: 178px;
  /*vertical-align: middle;*/
}
.default-images {
  width: 120px;
}
.interest-uploader {
  width: 178px;
}
</style>
